import { createComponentSDKModel } from '@wix/editor-elements-integrations/corvid';
import {
  composeSDKFactories,
  createAccessibilityPropSDKFactory,
  enableDocumentScrollSDKFactory,
} from '@wix/editor-elements-corvid-utils';

export const accessibilityPropsSDKFactory = createAccessibilityPropSDKFactory({
  enableLang: true,
});

export const sdk = composeSDKFactories([
  accessibilityPropsSDKFactory,
  enableDocumentScrollSDKFactory,
]);

export default createComponentSDKModel(sdk);
